// extracted by mini-css-extract-plugin
export default {"container":"KH-z","disabled":"LH-z","bgBlack":"MH-z","content":"NH-z","countdown":"OH-z","topCaption":"PH-z","topHeading":"QH-z","heading":"RH-z","copy":"SH-z"};